module.exports = __webpack_public_path__ + "files/8d2734d7b0adefc000c0c4c122589ebd.png";